import { AcroNode } from "./types";
import { renderNode } from "./renderNode";

export function renderRowsGrid(children: AcroNode[] | null | undefined, parentId?: string): string {
  const rows = (children ?? []);
  if (rows.length === 0) return '<div class="text-xs text-gray-400">No rows</div>';
  return rows.map((c) => `<div class="section-group-row flex flex-wrap gap-2 items-center">${renderNode(c, parentId)}</div>`).join("");
}
